import React from 'react';
import {decodePolyline} from '../Util'
import * as d3 from "d3";

import Basemap from '../components/Basemap'

class Map extends React.Component {

    componentDidMount(){	   
		
	   
	   if(this.props.activities.length>0){
		this.display(this.props.activities);
	   }
	
    }

	display(activities) {
		
		var featureCollection = { type: "FeatureCollection",
			features: []
		}
		
		activities.forEach(function(activity){
			if(activity.map.summary_polyline){
				var feature = {
					type: "Feature",
					properties: {},
					geometry: {
						type: "LineString",
						coordinates: decodePolyline(activity.map.summary_polyline).map(function (elt) { return [elt[1], elt[0]] })
					}
				};
				featureCollection.features.push(feature);
			}
		});

		var projection = d3.geoMercator().fitExtent([[this.props.poster.layout.margin, this.props.poster.layout.margin], [this.props.poster.layout.width-this.props.poster.layout.margin, this.props.poster.layout.height-this.props.poster.layout.margin-this.props.poster.legend.height-this.props.poster.legend.spacer]], featureCollection);

		var path = this.path = d3.geoPath().projection(projection);
		d3.select('#path').datum(featureCollection).attr('d', path);
	
	}

    shouldComponentUpdate(nextProps) {
		if(this.props.activities.length!==nextProps.activities.length){
			this.display(nextProps.activities);
			return true
		}
		if(this.props.activities.length>0 && this.props.activities[0].id===nextProps.activities[0].id){
			return false
		}else{
			if(nextProps.activities.length>0){
				this.display(nextProps.activities);
			}
			
			return true
		}
	}

    render() {
		console.log(this.props);
        

        return (
			<g>
				<Basemap activities={this.props.activities} poster={this.props.poster} offset={0}/>
				<path id='path' stroke-linejoin="round" strokeWidth={this.props.poster.style.route.strokeWidth} fill='none' stroke={this.props.poster.style.route.color} />
			</g>
        )
    }
}

export default Map;


// WEBPACK FOOTER //
// ./src/components/Map.js